import { jsx as _jsx } from "react/jsx-runtime";
import { useIsAuthenticated } from '@azure/msal-react';
import { Container } from '@mui/material';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { auth } from '../../application/features/auth/authSlice';
import { useAppSelector } from '../../application/store/useStore';
import { usePermissionGranted } from '../hooks/usePermissionGranted';
var ProtectedRoute = function (_a) {
    var children = _a.children, _b = _a.permissions, permissions = _b === void 0 ? [] : _b;
    var pathname = useLocation().pathname;
    var isAuthenticated = useIsAuthenticated();
    var authState = useAppSelector(auth);
    var hasPermission = usePermissionGranted({ permissions: permissions });
    var validUser = isAuthenticated && authState.loggedIn && hasPermission;
    if (!validUser)
        return (_jsx(Navigate, { to: '/unauthorized', state: {
                pathname: pathname,
                permissions: permissions
            } }));
    return (_jsx(Container, { maxWidth: false, sx: { paddingLeft: { xs: '0px', sm: '0px' }, paddingRight: { xs: '0px', sm: '0px' } }, children: children ? children : _jsx(Outlet, {}) }));
};
export default ProtectedRoute;
